import { DialogInteractOutsideEvent } from '@chakra-ui/react';

/*
 * The app's toasts render in their own portal and stay clickable over an open
 * modal or drawer. v2's Modal and Drawer closed only on a click on their own
 * overlay, so closing a toast left them open; v3 closes on any pointerdown or
 * focus outside the content, which closed the preview invoice drawer together
 * with the toast.
 *
 * zag's `persistentElements` would cover this too, but a modal layer waits up
 * to a second for each persistent element to exist and leaves that wait's
 * rejection unhandled when it doesn't, e.g. in every test without a toaster.
 */
export const isToastInteraction = (event: DialogInteractOutsideEvent) => {
  const target = event.detail.target as Element | null;
  return !!target?.closest?.('[data-scope="toast"]');
};
